export default "__VITE_ASSET__B7sWDzkP__"